export const normalizeMachineId = (value: unknown): number | undefined => {
  if (Array.isArray(value)) return undefined;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : undefined;
};
